import { motion, AnimatePresence } from "framer-motion";
import LogoContent from "./LogoContent";
import { useEffect } from "react";

export default function PageTransition({
  children,
  showContent,
  setShowContent,
}) {
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowContent(true);
    }, 400);

    return () => clearTimeout(timer);
  }, [setShowContent]);
  return (
    <AnimatePresence>
      {!showContent && (
        <motion.div
          className="bg-gray-900 w-full h-full fixed top-0 left-0 z-[50] flex justify-center items-center text-white  "
          initial={{ opacity: 1 }}
          exit={{ opacity: 0, y: -1200 }}
          transition={{ duration: 1 }}
        >
          <div className="flex flex-col">
            <LogoContent />
            <div className="flex justify-center items-center">
              <span className="text-3xl font-bold text-[#9E76B3]">
                {children}
              </span>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
